import angular from 'angular';
import { getTagColorKey } from '@/shared/components/tag/tagColors';

angular.module('cloudX').directive('cxTagInputXedit', [
  '$filter',
  'resourceFactorySvc',
  'dialogsSvc',
  function($filter, resourceFactorySvc, dialogsSvc) {
    return {
      restrict: 'E',
      template: `<div>
                  <div ng-if="readonly">
                    <span
                      ng-repeat="tag in readonlyTags track by tag.id"
                      class="document-tag {{ getTagColorClass(tag) }}"
                    >{{ tag.name }}</span>
                  </div>
                  <form data-editable-form name="tagsForm" class="tagsForm" onbeforesave="beforeSave($data.tags)" ng-if="!readonly">
                    <div ng-click="readValue(); tagsForm.$show();" editable-tags-input="innerValue" data-e-form="tagsForm" data-e-name="tags" name="tags" e-replace-spaces-with-dashes="false" e-placeholder="{{('Add a tag'|translate)}}" e-min-length="1" e-add-from-autocomplete-only="{{!!disableCreate}}" e-tag-class="getEditTagColorClass($tag)">
                      <a href="" ng-show="!tagsForm.$visible" title="{{('Edit tags'|translate)}}">
                        <span ng-show="readonlyTags.length">
                          <span
                            ng-repeat="tag in readonlyTags track by tag.id"
                            class="document-tag {{ getTagColorClass(tag) }}"
                          >{{ tag.name }}</span>
                        </span>
                        <i class="glyphicon glyphicon-pencil" ng-hide="readonlyTags.length"></i>
                      </a>
                      <editable-tags-input-auto-complete min-length="1" source="loadTags($query)" load-on-down-arrow="true" select-first-match="false"></editable-tags-input-auto-complete>
                    </div>
                    <div class="buttons">
                      <span ng-show="tagsForm.$visible">
                        <button type="submit" class="btn btn-inverse btn-xs" ng-disabled="tagsForm.$waiting" data-translate>Save</button>&nbsp;
                        <button type="button" class="btn btn-default btn-xs" ng-disabled="tagsForm.$waiting" ng-click="tagsForm.$cancel()" data-translate>Cancel</button>&nbsp;
                        <button type="button" style="float:right" class="btn btn-default btn-xs" ng-click="showAvailableTags()"> <i class="fa fa-info-circle margin5R"></i><span data-translate>Available tags</span></button>
                      </span>
                    </div>
                  </form>
                </div>`,
      scope: {
        value: '=data',
        save: '&',
        readonly: '=?',
        disableCreate: '=?',
      },
      link: function(scope) {
        scope.innerValue = [];
        scope.tags = null;
        scope.displayValue = '';
        scope.readonlyTags = [];
        scope.tagColorByName = {};
        scope.loadTags = function(search) {
          if (scope.tags !== null)
            return $filter('filter')(
              scope.tags.map(x => x.name),
              search,
            );
          return resourceFactorySvc
            .get('resource')
            .tags({}, function(data) {
              scope.tags = data;
            })
            .$promise.then(function() {
              return $filter('filter')(
                scope.tags.map(x => x.name),
                search,
              );
            });
        };
        scope.setDisplayValue = function(value) {
          if (typeof value === 'string') value = JSON.parse(value);
          scope.displayValue = (value || []).map(x => x.name).join(', ');
        };

        scope.getTagColorClass = function(tag) {
          return 'tag-color-' + getTagColorKey(tag && tag.color);
        };

        scope.setReadonlyTags = function(value) {
          if (typeof value === 'string') value = JSON.parse(value);
          scope.readonlyTags = angular.isArray(value) ? value : [];
        };

        scope.getEditTagColorClass = function($tag) {
          var name = $tag && $tag.text;
          var color = scope.tagColorByName[name];
          return 'tag-color-' + getTagColorKey(color);
        };

        // Prefetch all tags (incl. color) so edit-mode chips can be colored right away,
        // instead of only once the autocomplete has been queried.
        scope.$watch('tags', function(allTags) {
          var map = {};
          (allTags || []).forEach(function(t) {
            map[t.name] = t.color;
          });
          scope.tagColorByName = map;
        });
        scope.loadTags();

        scope.showAvailableTags = function() {
          dialogsSvc.showAvailableRelationTags().then(
            function({ selectedTags, updatedTags, removedTags } = parameters) {
              if (selectedTags && selectedTags.length) {
                const newTags = selectedTags.filter(
                  x => !(scope.innerValue || []).map(y => y.text).some(y => y === x),
                );
                scope.innerValue = [...scope.innerValue, ...newTags.map(x => ({ text: x }))];
              }
              if (updatedTags && updatedTags.length) {
                updatedTags.map(updatedTag => {
                  scope.value = scope.value.map(x => {
                    if (x.id === updatedTag.id) {
                      return {
                        ...x,
                        name: updatedTag.name,
                      };
                    }
                    return x;
                  });
                });

                scope.readValue();
                scope.setDisplayValue(scope.value);
                scope.setReadonlyTags(scope.value);
              }
              if (removedTags && removedTags.length) {
                scope.value = scope.value.filter(x => !removedTags.includes(x.id));
                scope.readValue();
                scope.setDisplayValue(scope.value);
                scope.setReadonlyTags(scope.value);
              }
            },
            function() {},
          );
        };

        scope.readValue = function() {
          var value = scope.value;
          if (typeof value === 'string') value = JSON.parse(value);
          if (angular.isArray(value)) {
            scope.innerValue = value.map(function(el) {
              return {
                text: el.name,
              };
            });
          } else {
            scope.innerValue = [];
          }
        };
        scope.$watch(
          'value',
          function(newValue, oldValue) {
            scope.readValue();
            scope.setDisplayValue(newValue);
            scope.setReadonlyTags(newValue);
          },
          true, //Force equal check, doesn't work without it...
        );
        scope.beforeSave = function(data) {
          var tags = data.map(function(el) {
            return el.text;
          });
          return scope.save({
            $data: tags,
          });
        };
      },
    };
  },
]);
